import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type IconName = 
  | 'layout-dashboard' 
  | 'package' 
  | 'warehouse' 
  | 'users' 
  | 'file-text'
  | 'search'
  | 'bell'
  | 'chevron-down'
  | 'chevron-up'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up-down'
  | 'user'
  | 'settings'
  | 'help-circle'
  | 'log-out'
  | 'plus'
  | 'clock'
  | 'check-circle'
  | 'eye'
  | 'bar-chart-3'
  | 'alert-triangle'
  | 'alert-circle'
  | 'shopping-cart'
  | 'user-plus'
  | 'dollar-sign'
  | 'trending-up'
  | 'circle'
  | 'rotate-ccw'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-up-circle'
  | 'arrow-down-circle'
  | 'minus'
  | 'edit'  | 'save'  | 'x'
  | 'trash-2'
  | 'phone'
  | 'mail'
  | 'arrow-left'
  | 'filter'
  | 'download'
  | 'upload'
  | 'loader'
  | 'activity'
  | 'scan-line'
  | 'truck'
  | 'package-plus'
  | 'printer'
  | 'message-square';

@Component({
  selector: 'ui-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg 
      [attr.width]="size" 
      [attr.height]="size" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      [attr.stroke-width]="strokeWidth"
      stroke-linecap="round" 
      stroke-linejoin="round"
      [class]="className">
      <ng-container [ngSwitch]="name">
        <!-- Dashboard -->
        <g *ngSwitchCase="'layout-dashboard'">
          <rect width="7" height="9" x="3" y="3" rx="1"></rect>
          <rect width="7" height="5" x="14" y="3" rx="1"></rect>
          <rect width="7" height="9" x="14" y="12" rx="1"></rect>
          <rect width="7" height="5" x="3" y="16" rx="1"></rect>
        </g>
        
        <!-- Package -->
        <g *ngSwitchCase="'package'">
          <path d="M7.5 4.27l9 5.15"></path>
          <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
          <path d="m3.3 7 8.7 5 8.7-5"></path>
          <path d="M12 22V12"></path>
        </g>
        
        <!-- Warehouse -->
        <g *ngSwitchCase="'warehouse'">
          <path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"></path>
          <path d="M6 18h12"></path>
          <path d="M6 14h12"></path>
          <rect width="12" height="12" x="6" y="10"></rect>
        </g>
        
        <!-- Users -->
        <g *ngSwitchCase="'users'">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </g>
        
        <!-- File Text -->
        <g *ngSwitchCase="'file-text'">
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M10 9H8"></path>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
        </g>
        
        <!-- Search -->
        <g *ngSwitchCase="'search'">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </g>
        
        <!-- Bell -->
        <g *ngSwitchCase="'bell'">
          <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
          <path d="m13.73 21a2 2 0 0 1-3.46 0"></path>
        </g>
        
        <!-- Chevron Down -->
        <g *ngSwitchCase="'chevron-down'">
          <path d="m6 9 6 6 6-6"></path>
        </g>
        
        <!-- User -->
        <g *ngSwitchCase="'user'">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </g>
        
        <!-- Settings -->
        <g *ngSwitchCase="'settings'">
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </g>
        
        <!-- Help Circle -->
        <g *ngSwitchCase="'help-circle'">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <path d="M12 17h.01"></path>
        </g>
        
        <!-- Log Out -->
        <g *ngSwitchCase="'log-out'">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16,17 21,12 16,7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </g>
        
        <!-- Plus -->
        <g *ngSwitchCase="'plus'">
          <path d="M5 12h14"></path>
          <path d="M12 5v14"></path>
        </g>
        
        <!-- Clock -->
        <g *ngSwitchCase="'clock'">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12,6 12,12 16,14"></polyline>
        </g>
        
        <!-- Check Circle -->
        <g *ngSwitchCase="'check-circle'">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22,4 12,14.01 9,11.01"></polyline>
        </g>
        
        <!-- Eye -->
        <g *ngSwitchCase="'eye'">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </g>
        
        <!-- Bar Chart 3 -->
        <g *ngSwitchCase="'bar-chart-3'">
          <path d="M3 3v18h18"></path>
          <path d="M18 17V9"></path>
          <path d="M13 17V5"></path>
          <path d="M8 17v-3"></path>
        </g>
        
        <!-- Alert Triangle -->
        <g *ngSwitchCase="'alert-triangle'">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
          <path d="M12 9v4"></path>
          <path d="M12 17h.01"></path>
        </g>
        
        <!-- Shopping Cart -->
        <g *ngSwitchCase="'shopping-cart'">
          <circle cx="8" cy="21" r="1"></circle>
          <circle cx="19" cy="21" r="1"></circle>
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
        </g>
        
        <!-- User Plus -->
        <g *ngSwitchCase="'user-plus'">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <line x1="19" y1="8" x2="19" y2="14"></line>
          <line x1="22" y1="11" x2="16" y2="11"></line>
        </g>
        
        <!-- Dollar Sign -->
        <g *ngSwitchCase="'dollar-sign'">
          <line x1="12" y1="1" x2="12" y2="23"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        </g>
          <!-- Trending Up -->
        <g *ngSwitchCase="'trending-up'">
          <polyline points="22,7 13.5,15.5 8.5,10.5 2,17"></polyline>
          <polyline points="16,7 22,7 22,13"></polyline>
        </g>
        
        <!-- Rotate CCW -->
        <g *ngSwitchCase="'rotate-ccw'">
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
          <path d="m3 3 2.26 5L10 6"></path>
        </g>
        
        <!-- Arrow Right -->
        <g *ngSwitchCase="'arrow-right'">
          <path d="M5 12h14"></path>
          <path d="m12 5 7 7-7 7"></path>
        </g>
          <!-- Arrow Left -->
        <g *ngSwitchCase="'arrow-left'">
          <path d="M19 12H5"></path>
          <path d="m12 19-7-7 7-7"></path>
        </g>
          <!-- Minus -->
        <g *ngSwitchCase="'minus'">
          <path d="M5 12h14"></path>
        </g>
        
        <!-- Chevron Up -->
        <g *ngSwitchCase="'chevron-up'">
          <path d="m18 15-6-6-6 6"></path>
        </g>
        
        <!-- Chevron Left -->
        <g *ngSwitchCase="'chevron-left'">
          <path d="m15 18-6-6 6-6"></path>
        </g>
        
        <!-- Chevron Right -->
        <g *ngSwitchCase="'chevron-right'">
          <path d="m9 18 6-6-6-6"></path>
        </g>
        
        <!-- Chevron Up Down -->
        <g *ngSwitchCase="'chevron-up-down'">
          <path d="m7 15 5 5 5-5"></path>
          <path d="m7 9 5-5 5 5"></path>
        </g>
        
        <!-- Alert Circle -->
        <g *ngSwitchCase="'alert-circle'">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </g>
        
        <!-- Arrow Up Circle -->
        <g *ngSwitchCase="'arrow-up-circle'">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m16 12-4-4-4 4"></path>
          <path d="m12 16 0-8"></path>
        </g>
        
        <!-- Arrow Down Circle -->
        <g *ngSwitchCase="'arrow-down-circle'">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m8 12 4 4 4-4"></path>
          <path d="m12 8 0 8"></path>
        </g>
        
        <!-- Edit -->
        <g *ngSwitchCase="'edit'">
          <path d="M7 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"></path>
          <path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3l8.385-8.415Z"></path>
          <path d="m16 5 3 3"></path>
        </g>
        
        <!-- Save -->
        <g *ngSwitchCase="'save'">
          <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"></path>
          <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
          <path d="M7 3v4a1 1 0 0 0 1 1h8"></path>
        </g>
          <!-- X -->
        <g *ngSwitchCase="'x'">
          <path d="m18 6-12 12"></path>
          <path d="m6 6 12 12"></path>
        </g>
        
        <!-- Trash-2 -->
        <g *ngSwitchCase="'trash-2'">
          <path d="M3 6h18"></path>
          <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
          <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
          <line x1="10" y1="11" x2="10" y2="17"></line>
          <line x1="14" y1="11" x2="14" y2="17"></line>
        </g>
          <!-- Phone -->
        <g *ngSwitchCase="'phone'">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
        </g>
        
        <!-- Mail -->
        <g *ngSwitchCase="'mail'">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </g>
        
        <!-- Arrow Left -->
        <g *ngSwitchCase="'arrow-left'">
          <path d="m12 19-7-7 7-7"></path>
          <path d="M19 12H5"></path>
        </g>
        
        <!-- Filter -->
        <g *ngSwitchCase="'filter'">
          <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46"></polygon>
        </g>
        
        <!-- Download -->
        <g *ngSwitchCase="'download'">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7,10 12,15 17,10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </g>

        <!-- Upload -->
        <g *ngSwitchCase="'upload'">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17,8 12,3 7,8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </g>
        
        <!-- Loader -->
        <g *ngSwitchCase="'loader'">
          <path d="M12 2v4"></path>
          <path d="m16.2 7.8 2.9-2.9"></path>
          <path d="M18 12h4"></path>
          <path d="m16.2 16.2 2.9 2.9"></path>
          <path d="M12 18v4"></path>
          <path d="m4.9 19.1 2.9-2.9"></path>
          <path d="M2 12h4"></path>
          <path d="m4.9 4.9 2.9 2.9"></path>
        </g>
        
        <!-- Activity -->
        <g *ngSwitchCase="'activity'">
          <path d="m22 12-4-4-4 4"></path>
          <path d="M6 12h4l4-8 4 8h4"></path>
        </g>
        
        <!-- Scan line: frame corners + sweep line (lucide scan-line) -->
        <g *ngSwitchCase="'scan-line'">
          <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
          <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
          <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
          <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
          <path d="M7 12h10"></path>
        </g>
        <!-- Alias truck to package icon -->
        <g *ngSwitchCase="'truck'">
          <path d="M7.5 4.27l9 5.15"></path>
          <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
          <path d="m3.3 7 8.7 5 8.7-5"></path>
          <path d="M12 22V12"></path>
        </g>
        <!-- Alias package-plus to package icon -->
        <g *ngSwitchCase="'package-plus'">
          <path d="M7.5 4.27l9 5.15"></path>
          <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
          <path d="m3.3 7 8.7 5 8.7-5"></path>
          <path d="M12 22V12"></path>
        </g>

        <!-- Printer -->
        <g *ngSwitchCase="'printer'">
          <polyline points="6 9 6 2 18 2 18 9"></polyline>
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
          <rect x="6" y="14" width="12" height="8"></rect>
        </g>

        <!-- Message square (note / comment) -->
        <g *ngSwitchCase="'message-square'">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </g>
        
        <!-- Circle (default) -->
        <g *ngSwitchDefault>
          <circle cx="12" cy="12" r="10"></circle>
        </g>
      </ng-container>
    </svg>
  `
})
export class IconComponent {
  @Input() name: IconName = 'circle';
  @Input() size: number | string = 16;
  @Input() strokeWidth: number = 2;
  @Input() className: string = '';
}
